<div class="row mb-2">
  <div class="col-12">
    <div class="form-check-inline">
      <h3 class="form-check-label">
        <input type="checkbox" [(ngModel)]="featureSwitch.TurnedOn" class="form-check-input" />
        {{featureSwitch.ClientSwitchName}} - {{featureSwitch.SwitchName}}
      </h3>
    </div>
    <button class="btn btn-link" (click)="toggleShowSettings()">{{settingsBtnLabel()}}</button> 
  </div>
  <div class="col-12">
    {{featureSwitch.SwitchDescription}}
  </div>
  <div class="col-12" *ngIf="showSettings()" >
    <h4>Feature Settings for Appointment Schedulling</h4>
    <div *ngFor="let setting of featureSwitch.Settings; let i = index">
      <div class="form-check-inline">
        <label class="form-check-label">
          <input type="checkbox" [(ngModel)]="setting.Active" class="form-check-input" />
          {{setting.SettingName}} - {{setting.Description}}
        </label>
      </div>
    </div>
    <div class="col-12 mb-2">
        <button class="btn btn-success" [class.button-loading]="isLoading()" (click)="save()">Save</button>
        <button class="btn btn-danger m-2" *ngIf="!isLoading()" (click)="toggleShowSettings()">Close</button>
    </div>
  </div>
  <hr />
</div>
